import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loading: false,
    show: true,
    region: [],
    toushou: [],
    language: [],
    domain: [],
    authorityList: [],
    statusList: []
  },
  mutations: {
    SET_LOADING (state, res) {
      state.loading = res
    },
    SET_SHOW (state, res) {
      state.show = res
    },
    REFRESH (state, vue) {
      state.show = false
      vue.$nextTick(() => (state.show = true))
    },
    SET_STATUS_LIST (state, res) {
      state.statusList = res
    },
    SET_REGION (state, res) {
      state.region = res
    },
    SET_TOUSHOU (state, res) {
      state.toushou = res
    },
    SET_LANGUAGE (state, res) {
      state.language = res
    },
    SET_DOMAIN (state, res) {
      state.domain = res
    },
    SET_AUTHORITY (state, res) {
      state.authorityList = res
    }
  },
  actions: {
  },
  modules: {
  },
});
